import React, { useState } from 'react';
import FadeIn from './FadeIn';

const testimonials = [
  {
    eyebrow: 'IICT UNIVERSITY • BUEA',
    quote: '"I came in not knowing how to use LinkedIn. I left with a profile, a strategy and three new professional connections. This changed my thinking completely."',
    name: 'Tour Participant',
    role: 'IICT University, South-West Region — 2024/2025',
    initials: 'IP',
    variant: 'dark',
  },
  {
    eyebrow: 'UNIVERSITY OF DOUALA',
    quote: '"The LinkedIn Tour showed me that my career story matters and that the world is watching — if I put myself out there. I updated my profile that same evening."',
    name: 'Tour Participant',
    role: 'University of Douala, Littoral Region — 2024/2025',
    initials: 'UD',
    variant: 'blue',
  },
  {
    eyebrow: 'ESSEC BUSINESS SCHOOL',
    quote: '"For the first time, I understood that my degree is just the beginning. What I build around it — my networks, my brand — is what will determine my career."',
    name: 'Tour Participant',
    role: 'ESSEC Business School, Douala — 2024/2025',
    initials: 'ES',
    variant: 'light',
  },
];

export default function Testimonials() {
  const [offset, setOffset] = useState(0);

  const prev = () => setOffset((o) => Math.max(0, o - 1));
  const next = () => setOffset((o) => Math.min(testimonials.length - 1, o + 1));

  return (
    <section className="testimonials">
      <div className="container">
        <FadeIn>
        <div className="testimonials__header">
          <h3 className="testimonials__title">What the Tour Participants Said</h3>
          <div className="testimonials__nav">
            <button className="nav-btn" onClick={prev} aria-label="Previous">&#8592;</button>
            <button className="nav-btn" onClick={next} aria-label="Next">&#8594;</button>
          </div>
        </div>
        </FadeIn>
        <FadeIn delay={1}>
        <div className="testimonials__grid">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className={`testimonial-card${t.variant === 'blue' ? ' testimonial-card--blue' : t.variant === 'light' ? ' testimonial-card--light' : ''}`}
            >
              <div className="testimonial-card__eyebrow">{t.eyebrow}</div>
              <p className="testimonial-card__quote">{t.quote}</p>
              <div className="testimonial-card__author">
                <div className="testimonial-card__avatar">{t.initials}</div>
                <div>
                  <div className="testimonial-card__name">{t.name}</div>
                  <div className="testimonial-card__role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        </FadeIn>
      </div>
    </section>
  );
}
